import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Button } from 'primereact/button';
import UserInfo from '../../../shared/UserInfo/UserInfo';
import { ImplementationFor, arraySort } from '../../../shared/utility';
import * as actions from '../../../store/actions/index';
import Messages from '../../../shared/UI/Messages/Messages';
import { Toast } from 'primereact/toast';
import axios from '../../../axios-url';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { DROPDOWN_CONFIG } from '../../../shared/Config';
import moment from 'moment';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Fieldset } from 'primereact/fieldset';
import Attachments from '../../../shared/UI/Attachments/Attachments';
import lodash from 'lodash';
import jsPDF from "jspdf";
import 'jspdf-autotable';
import { baseLogoImg } from '../../../shared/fontsAndBitImages';
import { baseLogoGlencoImg } from '../../../shared/fontsAndBitImagesGLENCO';
import axiosRetry from 'axios-retry';
import { VENDORREGISTRATION_ID } from '../../../shared/Config';

const Inputs = ({ field, metaData, onInputChange, ...props }) => {
    const type = props.match.params.type;
    const Component = ImplementationFor[parseInt(field.fieldType)] || false;

    return Component && (<Component
        {...field}
        {...props}
        name={field.fieldName}
        label={field.fieldDescription}
        placeholder={field.fieldDescription}
        onInputChange={onInputChange}
        metaData={Object.assign({}, metaData,{'Requested For': type === 'edit' ? props.keywordValuesList : props.subordinatesListData}, {"Category": props.categoryOptionsState},{"Expense Sub Category": props.SubcategoryOptionsState},{"Family Members": props.dependantstate})}
    /> || null);

}

let currencyList = [
    {"label":"KWD","value":248,"id":"KWD"},
    {"label":"USD","value":2,"id":"USD"},
    {"label":"EUR","value":11,"id":"EUR"},
    {"label":"INR","value":47,"id":"INR"},
    {"label":"OMR","value":78,"id":"OMR"},
    {"label":"SAR","value":89,"id":"SAR"},
    { "label": "AED", "value": 226, "id": "AED" },
    {"label":"BHD","value":230,"id":"BHD"},
    {"label":"GBP","value":19,"id":"GBP"},
    {"label":"CAD","value":22,"id":"CAD"},
    {"label":"CHF","value":63,"id":"CHF"},
    {"label":"DZD","value":237,"id":"DZD"},
    { "label": "IQD", "value": 245, "id": "IQD" },
    {"label":"JOD","value":246,"id":"JOD"},
    {"label":"PKR","value":79,"id":"PKR"},
    {"label":"PHP","value":83,"id":"PHP"},   
    { "label": "JPY", "value": 53, "id": "JPY" }]; 

let categoryList = [
    { "label": "International Business Travel", "value": '30a406ed-4c28-4639-84cd-bf30812f15ba', "id": '19C28133-B20E-4A6A-91A7-1DFC4B77B0DB' },
    { "label": "Local Travel", "value": '30a406ed-4c28-4639-84cd-bf30812f16ba', "id": '19C28133-B20E-4A6A-91A7-1DFC4B77B0DB'},
    { "label": "Children Education Expense", "value": "30a406ed-4c28-4639-84cd-bf30812f13ba", "id": '19C28133-B20E-4A6A-91A7-1DFC4B77B0DB' },
    { "label": "Immigration Expense", "value": "30a406ed-4c28-4639-84cd-bf30812f14ba", "id": '19C28133-B20E-4A6A-91A7-1DFC4B77B0DB' },
    { "label": "Membership & Subscription", "value": '30a406ed-4c28-4639-84cd-bf30812f17ba', "id": '19C28133-B20E-4A6A-91A7-1DFC4B77B0DB' },
    { "label": "Mobile Phone Reimbursement", "value": '30a406ed-4c28-4639-84cd-bf30812f19ba', "id": '19C28133-B20E-4A6A-91A7-1DFC4B77B0DB' }];
        

//const BUSINESS_TRIP_ID = '03C893B0-D69C-488D-9BD3-FBC55845F68F';

class VendorRegistration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            process: [],
            initialData: {},
            progressStarted: false,
            stageSequence: 0,
            DynamicSupervisor: false,
            dynamicSupervisorDisplay: false,
            DynamicSupervisorsList: [],
            requestId: false,
            error: false,
            popupType: 'submit',
            editing: false,
            TARequestNumber: [],
            requestattachments:[],
            cat:[],
            categoryOptionsState: [],
            requestDate: moment(),
            reqliststate:[],
            dependantstate: [],
            defvalue: '',
            ifaddupdatepressed: 0
        }
        this.initialize = this.initialize.bind(this);
        this.saveRequest = this.saveRequest.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleMethods = this.handleMethods.bind(this);
        this.handleContainer = this.handleContainer.bind(this);
        this.renderInput = this.renderInput.bind(this);
        
    }



    handleChange = (e, el) => {
        try
        {
        e.preventDefault();
        let { name, value, type, checked } = e.target;
        if (el.fieldDescription == "Expenditure Date") {
            value = moment(value).format('MM/DD/YYYY')
        }
        const { stageSequence,  TARequestNumber,keyword,cat,editing } = this.state;
        let { process } = this.state;
        const {metaData = {}} = this.props;

        let childRowNumber = el.childRowNmbr;
        let exchangeRate = 0.000.toFixed(3);
        let totalAmount = 0.000.toFixed(3);
        //let selcat=[];
        //let selcat1=[];
       // let valueupper = value.toUpperCase();
        // if (this.state.cat.length == 0 && metaData)
        // {
        //     this.setState({cat: metaData.Category});
        //     selcat=metaData.Category;

        // }




        // if ((el.fieldDescription === 'Hotel Expense' || el.fieldDescription === 'Transportation Expense' || el.fieldDescription === 'Meals Expense' || el.fieldDescription === 'Purchases Expense' || el.fieldDescription === 'Other Expenses') && ( isNaN(value) == true)) {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please enter Numerical Value in Expenses or if No expense' });
        //     return;
        // }      
        if(el.fieldDescription === 'Expense Type'){
        const selectedCategoryValue = value.toUpperCase();
        const selectedCategoryOptions = this.props.categoryOptions.filter(category => category.id === selectedCategoryValue)
        this.setState({categoryOptionsState: selectedCategoryOptions})
            if(selectedCategoryValue== '18C28133-B20E-4A6A-91A7-1DFC4B77B0DB')
            {
                this.setState({reqliststate: []})
            }

        }             
        if(el.fieldDescription === 'Category'){
            const selectedCategoryValue = value.toUpperCase();
            const selectedSubCategoryOptions = this.props.SubcategoryOptions.filter(category => category.id === selectedCategoryValue)
            if(selectedCategoryValue === '30A406ED-4C28-4639-84CD-BF30812F15BA'){   //travel authorization
                setTimeout(() => {
                   
                this.props.getrequestListgenp(this.props.userPosInfo.empID, '8AE27597-ADB2-491D-B592-7847A733BC05');
                
                },100);
                this.setState({  loading: true });
                const reqlist =   (this.props.reqlistgendata!== undefined) ? this.props.reqlistgendata: [ { label: "-Select-" , value: "00000000-0000-0000-0000-000000000000" }];
               // const reqlist = this.props.reqlistgendata;
                this.setState({reqliststate: reqlist})
                this.setState({ loading: false });
            }
            else if(selectedCategoryValue === '30A406ED-4C28-4639-84CD-BF30812F13BA'){   // Chlldren Education                   
                this.props.getdependantp(this.props.userPosInfo.empID, '2');
                this.setState({  loading: true });
                const dependant =   (this.props.dependantdata!== undefined  && this.props.dependantdata.length!== 0) ? this.props.dependantdata: [{ label: "-Select-" , value: "00000000-0000-0000-0000-000000000000" }];
                this.setState({dependantstate: dependant})
                this.setState({ loading: false });
            }
            else if(selectedCategoryValue === '30A406ED-4C28-4639-84CD-BF30812F14BA'  || selectedCategoryValue == '30A406ED-4C28-4639-84CD-BF30812F20BA'){  // Immigration                   
                this.props.getdependantp(this.props.userPosInfo.empID, 'KW01');
                this.setState({  loading: true });
                const spouse =   (this.props.dependantdata!== undefined && this.props.dependantdata.length!== 0) ? this.props.dependantdata:  [{ label: "-Select-" , value: "00000000-0000-0000-0000-000000000000" }];
                this.setState({dependantstate: spouse})
                this.setState({ loading: false });
            }
            else{

                this.setState({dependantstate: [],reqliststate: []})
            }

            this.setState({SubcategoryOptionsState: selectedSubCategoryOptions})
        }  
        let aoc = 0.000;
        if (el.fieldDescription === 'Amount in Original Currency') {
            this.setState({ loading: true});
            const { childRowNmbr: editedRowNumber } = el
            const re =  /^[0-9\b]+$/;
            if (e.target.value !='' && isNaN(e.target.value)) { // !re.test(e.target.value)) {
                aoc = 0.000;  //aoc = e.target.value;
                this.growl.show({ severity: 'error', summary: null, detail: 'Please enter amount in numbers' });
                this.setState({ loading: false});
                return;
            }
            else {
                this.setState({ loading: false});
                aoc =0.000 ;
            }
            // let exrate = process && this.getFieldUsingFielddesc("1054aab4-e054-4b36-a4d8-a05ae8d74df8", process,childRowNumber)?.fieldValue
            let exrate = process && this.getFieldUsingFielddesc('Exchange Rate', process, childRowNumber)?.fieldValue
            
            //        if (exrate && this.state.editing != false) {
                if (exrate) {
                
                let totalamt = this.state.editing.Exchange_Rate?this.state.editing.Exchange_Rate * e.target.value: exrate * e.target.value ;
                totalamt =  parseFloat(totalamt).toFixed(3);
                    let editingclone = { ...this.state.editing }
                editingclone.Amount_in_KWD = parseFloat(totalamt).toFixed(3);;
                    process = this.setFieldValueUsingFieldidrownum('3388e65a-0788-41eb-a441-b7c18ab01173', process, totalamt, childRowNumber)
                    process = this.setFieldValueUsingFieldidrownum('0fa7a63a-6113-4ed4-93d2-4ac5018a58f7', process, e.target.value, childRowNumber)
                    let dummy = process.filter((element, index) => index == 0).map((ep) => {
                        return ep.stage_Field.map((ep) => {
                            return (ep.fieldDescription === 'Amount in KWD') && ep || null;
                        }).filter(ep => ep != null).map(ep => Object.assign({}, {
                            amount: ep.fieldValue
                        }));
                    });
            
                    let totalAmount1 = parseFloat(0.000).toFixed(3);
                    let i;
                    let az =  parseFloat(0.000).toFixed(3);
                    for (i = 0; i < dummy[0].length; i++){
                        // az =  parseFloat(totalAmount).toFixed(3) * (exchangeRate.toFixed(5))
                        // totalAmount = parseFloat(totalAmount) +  parseFloat(az).toFixed(3);
                        az = parseFloat(dummy[0][i].amount).toFixed(3);
                        if (az && Number(az) ) {
                            totalAmount1 =  (parseFloat(totalAmount1) + parseFloat(az)).toFixed(3);
                        }
                    }
                    process = this.setFieldValueUsingFieldId('cb9b05b4-d11d-4521-ac3d-74d82bf726f7', process, totalAmount1)
            
                this.setState({
                    process: process.filter((p, i) => i <= parseInt(stageSequence) ).map(stage => Object.assign({}, { ...stage }, {
                        stage_Field: stage
                            .stage_Field.map(field => {
                                return Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === 'Amount in Original Currency') ? aoc : (type === 'checkbox' && field.fieldName === name) ? checked : (el.fieldType === '3' && field.fieldName === name) ? value.join(',') :  (field.fieldName === name) ? value : field.fieldValue })
                            })
                    }))
                });
              
            }
            else {
                process = this.setFieldValueUsingFieldidrownum('0fa7a63a-6113-4ed4-93d2-4ac5018a58f7', process, e.target.value, childRowNumber)
                this.setState({
                    process: process.filter((p, i) => i <= parseInt(stageSequence)).map(stage => Object.assign({}, { ...stage }, {
                        stage_Field: stage
                            .stage_Field.map(field => {
                                return Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === 'Amount in Original Currency') ? aoc : (type === 'checkbox' && field.fieldName === name) ? checked : (el.fieldType === '3' && field.fieldName === name) ? value.join(',') : (field.fieldName === name) ? value : field.fieldValue })
                            })
                    }))
                });
              
            }

         
            }
            
            if (el.fieldDescription === 'Amount in KWD') {
                return;
            }
            if (el.fieldDescription === 'Exchange Rate') {
                return;
            }
            

            
        if (el.fieldDescription === 'Original Currency') {
            const {childRowNmbr: editedRowNumber} = el
            this.setState({ loading: true});
            
            if(value != null){
            let stages = process.filter((p, i) => i < parseInt(stageSequence) + 1)
            let field = stages[0].stage_Field.filter(el => el.fieldDescription == 'Expenditure Date')
            let fieldValue = field[0].fieldValue;
            let advanceDate = moment(fieldValue).format("YYYY-MM-DD"); 
            if(advanceDate ==  "Invalid date"){
                this.growl.show({ severity: 'error', summary: null, detail: 'Please specify Date Of Expenditure before choosing currency' });
                this.setState({ loading: false});
                return;
            }
    
            let currency= currencyList.filter(el => el.value == value);
            //let currencyId=currency[0].id
            let currencyId = currency && currency[0].id || '';
            if (currency !='')
            {
            axios.get(`/master/api/GetExchangeRate?TrCurrency=${currencyId}&RequestDate=${advanceDate}`)
            .then(response => response.data) 
            .then(response => {                    
                   // let data = JSON.parse(response);
                    let data = {response};
                   // exchangeRate = data.Ukurs;
                   exchangeRate = data.response;
    
                    this.setState({ loading: false});
                        
                let kwdtotalAmount = 0.000.toFixed(3);
                let az = 0.000.toFixed(3);
    
                    let dummy = this.state.process.filter((element, index) => index == 0).map((el) => {
                        return el.stage_Field.map((el) => {
                            return (el.fieldDescription === 'Amount in KWD' ) && el || null;
                        }).filter(el => el != null).map(el => Object.assign({}, {
                            amount:el.fieldValue
                        }));
                    }) 
                let originalcfield = stages[0].stage_Field.filter(el => el.fieldDescription == 'Amount in Original Currency')
                
                
                kwdtotalAmount = dummy && +parseFloat(dummy[0][0].amount).toFixed(3);
                let rownum = parseInt(childRowNumber);
                // totalAmount =originalcfield && parseFloat(originalcfield[originalcfield.length - 1].fieldValue).toFixed(3);
                totalAmount =originalcfield && parseFloat(originalcfield[rownum].fieldValue).toFixed(3);
                if (currencyId == 'USD') {
                    az =  parseFloat(totalAmount).toFixed(3) * (exchangeRate.toFixed(5))
                    totalAmount =  parseFloat(az).toFixed(3);
                }
                else if (currencyId != 'KWD') {
                     az =  parseFloat(totalAmount).toFixed(3) * (exchangeRate.toFixed(5))
                    totalAmount =  parseFloat(az).toFixed(3);
                }
                else
                {
                    exchangeRate = 1.000;
                    totalAmount = parseFloat(totalAmount).toFixed(3) 
                }

                if (editing != false)
                {

                    let dummy = process.filter((element, index) => index == 0).map((ep) => {
                        return ep.stage_Field.map((ep) => {
                            return (ep.fieldDescription === 'Amount in KWD') && ep || null;
                        }).filter(ep => ep != null).map(ep => Object.assign({}, {
                            amount: ep.fieldValue
                        }));
                    });
            
                    let totalAmount1 = parseFloat(0.000);
                    let j=0;
                    let az =  parseFloat(0.000);
                    for (j = 0; j < dummy[0].length; j++) {
                        // az =  parseFloat(totalAmount).toFixed(3) * (exchangeRate.toFixed(5))
                        // totalAmount = parseFloat(totalAmount) +  parseFloat(az).toFixed(3);
                        if (j != rownum)
                            {
                            az = parseFloat(dummy[0][j].amount);
                        if (az && Number(az)) {
                            totalAmount1 = parseFloat(totalAmount1) + parseFloat(az);
                        }
                    }
                    }
                    totalAmount1 = totalAmount1 + parseFloat(totalAmount);
                    process = this.setFieldValueUsingFieldId('cb9b05b4-d11d-4521-ac3d-74d82bf726f7', process, totalAmount1.toFixed(3))

                    
                }

                    this.setState({
                        process: process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                            stage_Field: stage
                                .stage_Field.map(field => {
                                    return Object.assign({}, { ...field }, { fieldValue: (field.childRowNmbr == editedRowNumber && field.fieldDescription === 'Amount in KWD' && totalAmount ) ?  parseFloat(totalAmount).toFixed(3) : (field.childRowNmbr == editedRowNumber && field.fieldDescription === 'Exchange Rate' && exchangeRate ) ? exchangeRate  : (type === 'checkbox' && field.fieldName === name) ? checked : (el.fieldType === '3' && field.fieldName === name) ? value.join(',') : (field.fieldName === name) ? value : field.fieldValue })
                                })
                        }))
                    });
    
            }) 
                
                

                    
            .catch(err => {
                this.growl.show({ severity: 'error', summary: null, detail: 'Exchange Rate Fetch Failed' });
                this.setState({ loading: false});
            })
            }   
            else
            {
                this.growl.show({ severity: 'error', summary: null, detail: 'Select Valid Currency' });
                this.setState({ loading: false});
            }  
            
        }
    
        let kwdtotalAmount = parseFloat(0.000);
    
            let dummy = this.state.process.filter((element, index) => index == 0).map((el) => {
                return el.stage_Field.map((el) => {
                    return (el.fieldDescription === 'Amount in KWD') && el || null;
                }).filter(el => el != null).map(el => Object.assign({}, {
                    amount: el.fieldValue
                }));
            });
            // var loopData = ''
            // var i ;
            // for(i=0; i < data.length; i++){
            //     loopData += `<li>${data[i].name}</li>`
            // }

        // dummy.forEach(subData => kwdtotalAmount += parseFloat(subData.amount).toFixed(3));

       // kwdtotalAmount = dummy && +parseFloat(dummy[0][0].amount).toFixed(3);
    
        this.setState({
            process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue: type === 'checkbox' && field.fieldName === name ? checked : field.fieldName === name && el.fieldType === "3" ? value.join(',') : field.fieldName === name ? value :  field.fieldValue })) }))
        });
                   
                    //Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === 'Request Type' && RequestType) ? RequestType:(field.fieldDescription === 'Category' && CategoryId) ? CategoryId:(field.fieldDescription === 'Sub Category' && SubCategoryId) ? SubCategoryId:(field.fieldDescription === 'Queue Name' && QueueId) ? QueueId: type === 'checkbox' && field.fieldName === name ? checked : field.fieldName === name && el.fieldType === "3" ? value.join(',') : field.fieldName === name ? value : field.fieldValue })) }))
        //});
        this.setState({ payslipGenerated: false})
    
    
    }



        let TARequestField;
        if(el.fieldDescription === 'TA Request Number' && TARequestNumber && TARequestNumber.length > 0){
            TARequestField = TARequestNumber.find(_ => _.requestID.toString() === value.toString());
        }
        
        this.setState({
            process: process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === 'Assignment Type' && TARequestField && TARequestField.assignmentType) ? TARequestField.assignmentType : (field.fieldDescription === 'From Date' && TARequestField && TARequestField.fromDate) ? TARequestField.fromDate : (field.fieldDescription === 'To Date' && TARequestField && TARequestField.toDate) ? TARequestField.toDate : (field.fieldDescription === 'Resuming Date' && TARequestField && TARequestField.resumeDate) ? TARequestField.resumeDate : (field.fieldDescription === 'Total Days' && TARequestField && TARequestField.totalDays) ? TARequestField.totalDays : (field.fieldDescription === 'Destination City' && TARequestField && TARequestField.destinationCity) ? TARequestField.destinationCity : (field.fieldDescription === 'Assignment Purpose' && TARequestField && TARequestField.assignmentPurpose) ? TARequestField.assignmentPurpose : (type === 'checkbox' && field.fieldName === name) ? checked : (el.fieldType === '3' && field.fieldName === name) ? value.join(',') :  (field.fieldName === name) ? value : field.fieldValue })
                    })
            }))
        });

        // if (el.fieldDescription === 'Hotel Expense' || el.fieldDescription === 'Transportation Expense' || el.fieldDescription === 'Meals Expense' || el.fieldDescription === 'Purchases Expense' || el.fieldDescription === 'Other Expenses') {

        //     setTimeout(() => {
        //         let totalExpenses;
        //         let amount;
        //         totalExpenses = this.state.process.reduce((a, el, i) => {
        //             if (el.stage_Field && i === 0) {
        //                 const Add = el.stage_Field.reduce((b, k) => 
        //                 {
        //                 return(
        //                 k.fieldDescription === 'Hotel Expense' && el.fieldDescription !== 'Hotel Expense' && k.childRowNmbr == childRowNumber && k.fieldValue ? b + parseFloat(k.fieldValue) : 
        //                 k.fieldDescription === 'Hotel Expense' && el.fieldDescription === 'Hotel Expense' && k.childRowNmbr == childRowNumber && value ? b + parseFloat(value) :
        //                 k.fieldDescription === 'Transportation Expense' && el.fieldDescription !== 'Transportation Expense' && k.childRowNmbr == childRowNumber && k.fieldValue ? b + parseFloat(k.fieldValue) : 
        //                 k.fieldDescription === 'Transportation Expense' && el.fieldDescription === 'Transportation Expense'&& k.childRowNmbr == childRowNumber  && value ? b + parseFloat(value) :
        //                 k.fieldDescription === 'Meals Expense' && el.fieldDescription !== 'Meals Expense' && k.childRowNmbr == childRowNumber && k.fieldValue ? b + parseFloat(k.fieldValue) : 
        //                 k.fieldDescription === 'Meals Expense' && el.fieldDescription === 'Meals Expense' && k.childRowNmbr == childRowNumber && value ? b + parseFloat(value) :
        //                 k.fieldDescription === 'Purchases Expense' && el.fieldDescription !== 'Purchases Expense' && k.childRowNmbr == childRowNumber && k.fieldValue ? b + parseFloat(k.fieldValue) : 
        //                 k.fieldDescription === 'Purchases Expense' && el.fieldDescription === 'Purchases Expense' && k.childRowNmbr == childRowNumber && value ? b + parseFloat(value) :
        //                 k.fieldDescription === 'Other Expenses' && el.fieldDescription !== 'Other Expenses' && k.childRowNmbr == childRowNumber && k.fieldValue ? b + parseFloat(k.fieldValue) : 
        //                 k.fieldDescription === 'Other Expenses' && el.fieldDescription === 'Other Expenses' && k.childRowNmbr == childRowNumber && value ? b + parseFloat(value) : b)}
                        
        //                 , 0);
        //                 return Add;
        //             } else {
        //                 return a;
        //             }
        //         }, 0);

        //         let exchangeRate = this.state.process.filter((p, i) => i == 0).map(stage =>  stage.stage_Field.filter(field => {
                    
        //             return (field.fieldDescription === 'Exchange Rate' && field.childRowNmbr == childRowNumber);
        //         }))

        //         if(exchangeRate[0][0].fieldValue){
        //             let exrate = exchangeRate[0][0].fieldValue;
        //             amount = (totalExpenses / exrate).toFixed(2);
        //         }

        //         this.setState({
        //             process: process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
        //                 stage_Field: stage.
        //                     stage_Field.map(field => {
        //                         return Object.assign({}, { ...field }, { fieldValue: (field.fieldDescription === 'Assignment Type' && TARequestField && TARequestField.assignmentType) ? TARequestField.assignmentType : (field.fieldDescription === 'From Date' && TARequestField && TARequestField.fromDate) ? TARequestField.fromDate : (field.fieldDescription === 'To Date' && TARequestField && TARequestField.toDate) ? TARequestField.toDate : (field.fieldDescription === 'Resuming Date' && TARequestField && TARequestField.resumeDate) ? TARequestField.resumeDate : (field.fieldDescription === 'Total Days' && TARequestField && TARequestField.totalDays) ? TARequestField.totalDays : (field.fieldDescription === 'Destination City' && TARequestField && TARequestField.destinationCity) ? TARequestField.destinationCity : (field.fieldDescription === 'Assignment Purpose' && TARequestField && TARequestField.assignmentPurpose) ? TARequestField.assignmentPurpose : (type === 'checkbox' && field.fieldName === name) ? checked : (el.fieldType === '3' && field.fieldName === name) ? value.join(',') :(field.fieldDescription === 'Total Expenses' && field.childRowNmbr == childRowNumber && totalExpenses ) ? totalExpenses: (field.fieldDescription === 'Amount(KWD)' && field.childRowNmbr == childRowNumber && amount) ? amount :  (field.fieldName === name) ? value : field.fieldValue })
        //                     })
        //             }))
        //         });

        //     }, 50);
            

        // }
        
    }
    catch (error) {
        this.setState({error : error})
     }


    }

    handleAttachment = (data, type) => {
        try
        {
        let index = 0;
        let attachmentData = data.map((el) => {
            index++
            return{
                Requestattachmentid: '00000000-0000-0000-0000-000000000000' ,
                Requestid :'00000000-0000-0000-0000-000000000000',
                SiNo: index ,
                UploadPath:el.filePath ,
                FileName:el.fileName ,
                Extension :el.fileExtension,
                Createdby: this.props.loggedUserDetail.empID ,
                Createddate: moment().format('MM/DD/YYYY') ,
                Updatedby: this.props.loggedUserDetail.empID ,
                Updateddate: moment().format('MM/DD/YYYY') ,
                CompanyId: this.props.loggedUserDetail.CompanyId ,
                Stagenum: 0 ,
            }
        });
            this.setState({ requestattachments: attachmentData });
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    setFieldValueUsingFieldId(inputFieldId, process, valueToBeSet) {
        try
        {
        const { stageSequence } = this.state;

        const updatedProcess =  process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldId ? valueToBeSet : field.fieldValue })
                    })
        }))

            return updatedProcess
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    setFieldValueUsingFieldidrownum(inputFieldid, process, valueToBeSet,childRowNmbr) {
        
        try
        {
        const { stageSequence } = this.state;

        const updatedProcess =  process.filter((p, i) => i <= parseInt(stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, {
                stage_Field: stage
                    .stage_Field.map(field => {
                        return Object.assign({}, { ...field }, { fieldValue: field.fieldId === inputFieldid && field.childRowNmbr == childRowNmbr  ? valueToBeSet : field.fieldValue })
                    })
        }))

            return updatedProcess
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    handleContainer = (field) => {
        try {
        this.setState({ loading: true,ifaddupdatepressed: 1 });
        const { process, stageSequence } = this.state;
        const { location } = this.props;
        let cldr = field.childRowNmbr;
        let flag = 0;
            let vcategory = '';

            let kwdtotalAmount = parseFloat(0.000).toFixed(3);
    
            let dummy = this.state.process.filter((element, index) => index == 0).map((el) => {
                return el.stage_Field.map((el) => {
                    if (el.fieldDescription === 'Description' && (el.fieldValue === "0" || el.fieldValue === "")) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'please enter description' });
                        flag = 1;
                        return;
                    }
                    if (el.fieldDescription === 'Category') {
                        vcategory = el.fieldValue;
                        
                    }
                    if (el.fieldDescription === 'Family Members' && el.fieldValue === null && (vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F14BA' || vcategory.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F13BA')) {
                        this.setState({ loading: false });
                        this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Family Member' });
                        flag = 1;
                        return;
                    }
                    return (el.fieldDescription === 'Amount in KWD') && el || null;
                }).filter(el => el != null).map(el => Object.assign({}, {
                    amount: parseFloat( el.fieldValue)
                }));
            });

            if (flag === 1) return;

            let totalAmount = parseFloat(0.000);
            let j;
            for (j = 0; j < dummy[0].length; j++) {
                totalAmount += parseFloat(dummy[0][j].amount)
            }

            let error = 0;
            const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                if (stageIndex === 0) {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    const containerGroup = lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || [];
                    const fields = containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1] || [];
                    if (fields && fields.length > 0) {
                        let count = stageField.length + 1;
                        let sequence = stageField.length + 1;
                        const newFields = fields.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, 10);
                            a.push(Object.assign({}, { ...el }, {
                                fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: field.fieldName, childRowNmbr: Object.keys(containerGroup).length.toString(), fieldValue: (el.fieldType == 1) ? ((field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount : (el.fieldDescription == 'Hotel Expense') ? 0 :
                                    (el.fieldDescription == 'Transportation Expense') ? 0 : (el.fieldDescription == 'Meals Expense') ? 0 : (el.fieldDescription == 'Purchases Expense') ? 0 : (el.fieldDescription == 'Other Expenses') ? 0 : '') : (el.fieldDescription == 'Exchange Rate') ? 0 : null
                            }));
                            return a;
                        }, []);
                        return Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.concat(newFields) });
                    } else if (location && location.state && location.state.stagesequence === stageIndex) {
                        error = 1;
                        return stage;
                    }
                    else {
                        return stage;
                    }
                } else {
                    return stage;
                }
            });
            j = 0;
        
           //  const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldId("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount)

            const initialValuesWithUpdatedTotal = this.setFieldValueUsingFieldidrownum("cb9b05b4-d11d-4521-ac3d-74d82bf726f7", InitialValues, totalAmount, cldr)

        
            // InitialValues =InitialValues.filter((p, i) => i = 0 ).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue:  (field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount: field.fieldValue })) }))

 

        
            //dummy.forEach(subData => kwdtotalAmount += subData.amount);
            // let totalAmount = 0.000.toFixed(3);
            //     let i ;
            //     for(i=0; i < dummy[0].length; i++){
            //         totalAmount = parseFloat(totalAmount) + dummy[0][i].amount
            //     }
            // kwdtotalAmount = dummy && +parseFloat(dummy[0][0].amount).toFixed(3);
            //: (field.childRowNmbr == editedRowNumber && field.fieldDescription === 'Total Amount in KWD' && totalAmount ) ? totalAmount 


            setTimeout(() => {
                try
                {

                    if (error) {
                        this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
                        return;
                    }
                  
                     this.setState({ loading: false, process: initialValuesWithUpdatedTotal });
                   
                    //this.setState({ loading: false });
                //this.setState({ loading: false, process: InitialValues });
                //this.setState({ loading: false }, { process: process });

                }

                catch (error)
                {
                    //handleExpectedError(error);
                    this.setState({ error: error });
                } 
            
            }, 3000);

        }

        catch (error)
        {
            //handleExpectedError(error);
            this.setState({ error: error });
        }
       
        //i = 0;

        // this.setState({
        //     process: this.state.process.filter((p,i) => i <= 20  ).map(stage => Object.assign({}, { ...stage }, {
        //         stage_Field: stage
        //             .stage_Field.map(field => {
        //                 return Object.assign({}, { ...field }, { fieldValue:  field.fieldDescription === 'Total Amount in KWD' && totalAmount ? totalAmount  : field.fieldValue })
        //             })
        //     }))
        // });

   
        // this.setState({
        //     process: this.state.process.filter((p, i) => i <= parseInt(this.state.stageSequence) + 1).map(stage => Object.assign({}, { ...stage }, { stage_Field: stage.stage_Field.map(field => Object.assign({}, { ...field }, { fieldValue:  (field.fieldDescription === 'Total Amount in KWD' && totalAmount) ? totalAmount: field.fieldValue })) }))
        // });
    }

    

    rowExpansionTemplate = (data) => {
        try
        {
        let currency = currencyList.find(el => el.value == data.Original_Currency);
        let currencyId = currency && currency.id || '';
            let currencyLabel = currency && currency.label || '';
           // let fml = dependantdata.find(ef => ef.value == data.familyMembers);

        
        return (
            <div className="p-grid p-fluid" style={{ padding: '2em 1em 1em 1em' }}>
                <div className="p-col-12 p-md-12">
                    <div className="p-grid">

                        <div className="p-md-3">Date Of Expenditure: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expenditure_Date}</div>

                        {/* <div className="p-md-3">Family Members: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Description}</div> */}
                        {data.Family_Members && 
                        <><div className="p-md-3">Family Members: </div><div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Family_Members}</div></>
                        }

{/*                         <div className="p-md-3">Expense Sub Category:</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expense_Nature}</div>

                        <div className="p-md-3">Amount In Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Hotel_Expense + ' ' + currencyId}</div>

                        <div className="p-md-3">Exchange Rate: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Transportation_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Amount(KWD)</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Meals_Expense  + ' ' + currencyId}</div> */}

                        <div className="p-md-3">Expense Sub Category:</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Expense_Sub_Category}</div>

                        <div className="p-md-3">Amount In Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Amount_in_Original_Currency + ' ' + currencyLabel}</div>

                        {/* <div className="p-md-3">Exchange Rate: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Exchange_Rate  + ' ' + currencyId}</div> */}

{/*                         <div className="p-md-3">Amount(KWD)</div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Meals_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Purchases Expense </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Purchases_Expense  + ' ' + currencyId}</div>

                        <div className="p-md-3">Other Expenses </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Other_Expenses  + ' ' + currencyId}</div>

                        <div className="p-md-3">Total Expenses: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Total_Expenses  + ' ' + currencyId}</div>

                        <div className="p-md-3">Original Currency: </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{currencyLabel || data.Original_Currency || ''}</div> */}

                        <div className="p-md-3">Exchange Rate:  </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Exchange_Rate}</div>

                        <div className="p-md-3">Amount In KWD:  </div>
                        <div className="p-md-3" style={{ fontWeight: 'bold' }}>{data.Amount_in_KWD}</div>
                    </div>
                </div>
            </div>
            
            );
        }
        catch (error) {
            this.setState({error : error})
         }  
    }

    effectiveDateHandler() {
        try
        {
        var dates = []
        var dt = new Date()
        var month = dt.getMonth()
        var year = dt.getFullYear();
        for (let i = -24; i < 24; i++) {
            dates.push(moment(new Date(year, month - i, 1)).format('MM/DD/YYYY'))
            }
        }
        catch (error) {
            this.setState({error : error})
         }
        // disabledDays = dates
    }

    initialize = (process, type, field) => {
        try {
            
            const { tableLists, location = {} } = this.props;
            const { stageSequence, requestDate } = this.state;
            const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;
            const pageType = this.props.match.params.type;
            const empID = this.props.loggedUserDetail.empID;
            const pendingWith = location && location.state && location.state.pendingWith
            const requestFrom = location && location.state && location.state.requestFrom;


            let count = 1;
            let sequence = 1;
            if (type === 'progress' || type === 'add' || type === 'edit') {
                this.setState({ process: [], loading: true });

                const InitialValues = process.filter((p, i) => i <= parseInt(stageSequence) + 1).map((stage, stageIndex) => {
                    const stageField = arraySort(stage.stage_Field, 'fieldSequence');
                    return Object.assign({}, { ...stage }, {
                        stage_Field: stageField.reduce((a, el) => {
                            const startIndex = el.fieldName.substring(0, 10);
                            if (type === 'add' && el.parentFieldId === '000' && el.fieldType != '9') {
                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, fieldValue: el.fieldDescription === 'Request Date' && requestDate || el.fieldDescription === 'Total Amount in KWD' && 0.000.toFixed(3) || (el.fieldDescription === 'Requested For' && empID) || el.fieldValue, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                            } else if (type === 'add' && el.fieldType === '9') {
                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, type: el.fieldDescription === 'Amount in Original Currency' ? "number" : "number" }));
                                const fields = stageField.filter(_ => _.parentFieldId === el.fieldName);
                                const lastItem = a[a.length - 1];
                                fields.map((subField) => {
                                    a.push(Object.assign({}, { ...subField }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName, childRowNmbr: '0' }));
                                })
                            } else if (type === 'edit') {
                                a.push(Object.assign({}, { ...el }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, stage_FieldsList: [], disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}` }));
                                const lastItem = a[a.length - 1];
                                if (el.stage_FieldsList && el.stage_FieldsList.length > 0) {
                                    el.stage_FieldsList.map((subField, subIndex) => {
                                        if (subIndex != 0) {
                                            subField.stage_FieldsListc2.map(c2 => {
                                                a.push(Object.assign({}, { ...c2 }, { fieldName: `${startIndex}${count++}`, fieldSequence: sequence++, disabled: (requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false, stageSequence: stageIndex, stageNum: `00${stageIndex}`, parentFieldId: lastItem.fieldName }));
                                            })
                                        }
                                    })
                                }
                            }
                            return a;
                        }, [])
                    })
                });

                setTimeout(() => this.setState({ loading: false, process: InitialValues }), 3000);
            } else {

                this.growl.show({ severity: 'error', summary: null, detail: 'please provide correct details' });
            }
        }
        catch (error) {
            this.setState({error : error})
         }

    }

    saveRequest = (submitType) => {
        const { containerData } = this.props;
        const { process, ifaddupdatepressed } = this.state;
        const type = this.props.match.params.type;

        let RequestAttributes = [];
        let Comment = '';
        let Category = '';
        let SubCategory = '';
        let TravelAuthorization = '';
      //  let RequestType = false;
        let RequestedFor = '';
        let RequestDate = '';
        let Attachments = '';
        let duplicatecategory = '';
        let vendorname = '';
        // if (type != 'edit' && ifaddupdatepressed === 0)
        //     {
        //         this.growl.show({ severity: 'error', summary: null, detail: 'Please make sure you have pressed Add button after entering expense detail' });
        //         return
        //     }
        process.map((stage, stageIndex) => {
            stage.stage_Field.map(el => {

                if (el.fieldDescription === 'Requested For') {
                    RequestedFor = el.fieldValue;
                }
                if (el.fieldDescription === 'Vendor Name') {
                    vendorname = el.fieldValue;
                }

                RequestAttributes.push(Object.assign({}, { ...el }, { fieldValue: (el.fieldType === "7" || el.fieldType === "8") ? moment(el.fieldValue).format('MM/DD/YYYY') : el.fieldValue }));
            })
        });

        if (submitType === 'submit') {
            // if (!RequestedFor){
            //     this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Requested For Before submitting' })
            //     return  
            // }
            if (!RequestedFor) {
                this.growl.show({ severity: 'error', summary: null, detail: 'Please Select RequestedFor Before submitting' })
                return
            }
            if (!vendorname) {
                this.growl.show({ severity: 'error', summary: null, detail: 'Please Select Vendor Name Before submitting' })
                return
            }
        }

        // if (Category.toUpperCase() === '30A406ED-4C28-4639-84CD-BF30812F15BA' && !TravelAuthorization) {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please choose Travel Authorization before Submitting/Saving' });
        //     return

        // }

        // if(!RequestType){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please choose Expense Type before Submitting/Saving' });
        //     return;
        // }
        // if (duplicatecategory == 'yes')
        // {
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Sub Categories of different category not allowed.Please enter correct sub category' });
        //     return;           
        //     }


        // if(!RequestedFor){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please choose Requested For before Submitting/Saving' });
        //     return;
        // }

        // if(!RequestDate){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please choose Request Date before Submitting/Saving' });
        //     return;
        // }

        // if(this.state.requestattachments.length===0){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please upload attachments before Submitting/Saving' });
        //     return;
        // }

        // if(!Comment){
        //     this.growl.show({ severity: 'error', summary: null, detail: 'Please enter Remarks' });
        //     return;
        // }
        

        let data = {
            FromDate: moment().format('MM/DD/YYYY'),
            ToDate: moment().format('MM/DD/YYYY'),
            VisaCount: 0,
            TicketCount: 0,
            RequestDesc: 'Vendor RegistrationRequest',
            IsActive: true,
            RequestDate: moment().format('MM/DD/YYYY'),
            EmpID: this.props.loggedUserDetail.empID,
            LoginEmployeeID: this.props.loggedUserDetail.empID,
            CompanyID: this.props.loggedUserDetail.CompanyId,
            Remark: Comment,
            RequestedFor: this.props.loggedUserDetail.empID,
//            RequestType : RequestType,
            ProcessID: VENDORREGISTRATION_ID,
            RequestAttributes: RequestAttributes,
            Requestattachments: this.state.requestattachments,
            Requestforms: [],
            Requestactions: [],
            stagesequence: this.state.stageSequence,
            processNum: containerData.processNum
        };


        if (process && process.length > 0) {

            let model = 'requestSave';
            if (submitType === 'submit') {
                if (this.state.DynamicSupervisor) {
                    data.DynamicSupervisor = this.state.DynamicSupervisor;
                }

                model = 'VendorRegistration';
            }

            if (submitType === 'delegate') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Delegate_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'VendorRegistration';
            }

            if (submitType === 'forward') {
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Forward_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                model = 'VendorRegistration';
            }

            if (submitType === 'return' && this.state.DynamicSupervisor) {
                const SelDropdownEmployee = this.state.DynamicSupervisorsList.find(el => el.value === this.state.DynamicSupervisor);
                data.DynamicSupervisor = this.state.DynamicSupervisor;
                data.Return_WF_Level_ID = this.props.location && this.props.location.state && this.props.location.state.request_WF_LEVEL_ID || '';
                data.Return_to_WF_Level_ID = SelDropdownEmployee && Object.keys(SelDropdownEmployee).length > 0 && SelDropdownEmployee.Request_WF_LEVEL_ID;
            }


            if (this.state.requestId) {
                data.requestId = this.state.requestId
            }

            var stringifyData = JSON.stringify(data);
            var datas = { Key: stringifyData };

            let url = (type === 'edit') ? '/master/api/UpdateDynamicData?model=' + model : '/master/api/InsertDynamicData?model=' + model;

            if (submitType === 'submit') {
                url = '/master/api/workflow/submit?type=' + model;
            } else if (submitType === 'reject') {
                url = '/master/api/workflow/reject?type=' + model;
            } else if (submitType === 'delegate') {
                url = '/master/api/workflow/delegate?type=' + model;
            } else if (submitType === 'forward') {
                url = '/master/api/workflow/forward?type=' + model;
            } else if (submitType === 'return') {
                url = '/master/api/workflow/return?type=' + model;
            } else if (submitType === 'cancel') {
                url = '/master/api/workflow/cancel?type=' + model;
            }

            this.setState({ loading: true });

            axios.post(url, JSON.stringify(datas))
                .then(response => {

                    this.setState({ loading: false });
                    if (submitType === 'submit' || submitType === 'return') {
                        if (response.status === 200) {
                            if (response.data.id !== undefined && response.data.id === 'DYNAMIC') {
                                let submitValue = response.data.result && JSON.parse(response.data.result);
                                let tableValue = [];
                                if (submitValue.Table && submitValue.Table !== undefined && submitValue.Table.length > 0) {
                                    tableValue = submitValue.Table.map(list => {
                                        return { label: list.NAME, value: list.EMPLOYEE_ID, id: list.EMPLOYEE_NO ,Request_WF_LEVEL_ID: list.Request_WF_LEVEL_ID}
                                    })
                                }
                                if(submitType === 'submit'){
                                    this.setState({dialogBoxText: "Select Supervisor"})
                                }
                                if(submitType === 'return'){
                                    this.setState({dialogBoxText: "Return To", popupType:'return'})
                                }
                                this.setState({ requestId: response.data.requestId, dynamicSupervisorDisplay: true, DynamicSupervisorsList: tableValue })
                            } else {
                                this.growl.show({ severity: 'success', summary: null, detail: 'Vedor Registration request submitted successfully' });
                                this.props.history.push('/dashboard');
                            }
                        } else {
                            this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                        }

                    } else {
                        this.growl.show({ severity: 'success', summary: null, detail: 'Vendor Registration request saved successfully' });
                        this.props.history.push('/dashboard');
                    }

                })
                .catch(err => {
                    this.setState({ loading: false })
                    this.growl.show({ severity: 'error', summary: null, detail: 'Failed' });
                })

        }

    }

    getFieldUsingFieldId(inputFieldId, process) {
        try
        {
        return process?.reduce((a, fld) => {
            const field = fld.stage_Field.find((el) => el.fieldId === inputFieldId)
            if (field) {
                a = field
            }
            return a
        }, false)
    }
    catch (error) {
        this.setState({error : error})
     }
    }

    getFieldUsingFielddesc(inputFielddesc, process, childRowNmbr) {
        try{
        return process?.reduce((a, fld) => {
            const field = fld.stage_Field.find((el) => el.fieldDescription === inputFielddesc && el.childRowNmbr === childRowNmbr)
            if (field) {
                a = field
            }
            return a
        }, false)
    }
    catch (error) {
        this.setState({error : error})
     }
    }

    uploadGeneratedEC = (generatedPdf) => {
        return new Promise((resolve, reject) => {
            axiosRetry(axios, { 
                retries: 8,
                retryCondition: (error) => {
                    // if retry condition is not specified, by default idempotent requests are retried
                    return error;
                  },
            });//For retrying 8 times
            axios.post(`/master/api/Base4ToPDF`, generatedPdf)
            .then((response => {
                resolve(response);
            })).catch((err) => {
                reject(err);
            })
        })
    }  

    generateEC = (type) =>{
        return new Promise((resolve ,reject)=>{ //Implementing promise for this function to be used in the "saveRequest" function for uploading pdf before saving request
        this.setState({loading:true});
        const { process } = this.state;
        //let InvoiceNumber = this.state.Invoicenumber ;
        let ECId;
        // let si=0;
        // process.map((stage, si) => {
        //     stage.stage_Field.map(el => {
        //         if (el.fieldDescription === 'Invoice Number' ) {
        //             InvoiceNumber = el.fieldValue;
        //         }
        //     })
        // });

        if (this.state.requestId) {
            ECId = this.state.requestId
        }

       // axiosRetry(axios, { retries: 3 });//For retrying 8 times
        axios.get('/master/api/GetECforprint?ECId=' + ECId)
        .then((response => {
            //assingning variable from response(start)
            let data = response.data;
            let ECHDR = (data.waEC) ? data.waEC : [];
            let ECrequesterdata = ( data.requesterdata ) ? data.requesterdata : [];
            let ECLine = (data.itECLine && data.itECLine.length > 0) ? data.itECLine : [];
            let ECApproval = (data.approvals && data.approvals.length > 0) ? data.approvals : [];
            // let workpermitStatusRei = (data.workpermitStatusRei && data.workpermitStatusRei.length > 0) ? data.workpermitStatusRei : [];
            // let workpermitStatusSur = (data.workpermitStatusSur && data.workpermitStatusSur.length > 0) ? data.workpermitStatusSur : [];

            let precautionsTableHeader = [];
            let precautionsTableBody = [];
            let precautionsTableData = [];

            let ECLineTableHeader = [];
            let ECLineTableBody = [];
            let ECLineTableData = [];   
            
            let ECApprovalsTableHeader = [];
            let ECApprovalsTableBody = [];
            let ECApprovalsTableData = [];   
            
            
            //finding if there are multiple wcds in the workpermit
            let ECitem= 'none';
            let firstPageWcditem = [];

                if(ECLine.length > 0){
                    ECitem = 'multiple';
                    firstPageWcditem = ECLine[0];
                } else {
                    ECitem = 'single';
                    firstPageWcditem = ECLine[0];
                }
        

            let ECnumber = ECHDR.requestNum || 'N/A';       
                this.setState({ECnumber:ECnumber});
            let ECdate = ECHDR.requestDate || 'N/A';
            let category = ECHDR.category || 'N/A';            
            let comment = ECHDR.comment || 'N/A';
            let expenseType = ECHDR.expenseType || 'N/A';            
            let requestedFor  = ECHDR.requestedFor || 'N/A';
            let totalAmountInKWD = ECHDR.totalAmountInKWD || 'N/A';            
            let travelAuthorization = ECHDR.travelAuthorization || 'N/A';

            let Requestername = ECrequesterdata.requestername || '';
            let position = ECrequesterdata.position || '';
            let department = ECrequesterdata.department || '';
            let doj = ECrequesterdata.doj || '';          

            // let NameAr =  Customer.NameAr || 'N/A';              
            // let BuildingNo =  Customer.BuildingNo || 'N/A';  
            // let Street =  Customer.Street || 'N/A';              
            // let District =  Customer.District || 'N/A';   
            // let City =  Customer.City || 'N/A';              
            // let CountryCode =  Customer.CountryCode || 'N/A';  
            // let CountryName =  Customer.CountryName || 'N/A';              
            // let PostalCode =  Customer.PostalCode || 'N/A';  
            // let AdditionalNo =  Customer.AdditionalNo || 'N/A';              
            // let VatNo =  Customer.VatNo || 'N/A';  
            // let OtherNo =  Customer.OtherNo || 'N/A';              
            // let BankName =  Customer.BankName || 'N/A';  
            // let BankAccountName =  Customer.BankAccountName || 'N/A';              
            // let BankAccountNo =  Customer.BankAccountNo || 'N/A';  
            // let BankBranch =  Customer.BankBranch || 'N/A';              
            // let Ibanno =  Customer.Ibanno || 'N/A';                                     
            // let Swiftcode =  Customer.Swiftcode || 'N/A';              
            // let BankCity =  Customer.BankCity || 'N/A';  
            // let BankCountry =  Customer.BankCountry || 'N/A';              
            // let BankAddress =  Customer.BankAddress || 'N/A';  



            // let isPermitAccess = (rWorkPermit.wapiuse == "ACC") ? true : false
            // let safetyDocumentNumber = rWorkPermit.sappermitNo;
            // let keySafeNumber = (isPermitAccess) ? `AZN`: `Key Safe Key Number: \n${rWorkPermit.lockboxKey || 'N/A'}`;// if heading is permit access, this is AZN 
            // let dpSheetNumber = rWorkPermit.wcdnr || 'N/A';
            // let riskAssesmentNumber = rWorkPermit.riskassessmentno || 'N/A';
            // let workOrderNumber = rWorkPermit.workOrderNo || 'N/A';
            // let workBriefInstructions = rWorkPermit.permitDescription || 'N/A';
            // let kksNumber = rWorkPermit.tplnr || 'N/A';
            // let kksDescripton = rWorkPermit.tptxt || 'N/A';

            // let approverName = rWorkPermit.approver || '';
            // let approveTime = (rWorkPermit.approvetime.length > 0) ?  rWorkPermit.approvetime.slice(0, -1) : ''; //to remove the extra ":" coming from api
            // let approvedDate = (moment(rWorkPermit.approvedate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.approvedate).format("DD/MM/YYYY") ;

            // let issuedByName= rWorkPermit.issuedbyname || '';
            // let issuedDate= (moment(rWorkPermit.issueddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.issueddate).format("DD/MM/YYYY") ;
            // let issuedTime= (moment(rWorkPermit.issueddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.issueddate).format("h:mm:ss A") ;

            // let acceptedByName= rWorkPermit.acceptedbyname || '';
            // let acceptedDate= (moment(rWorkPermit.accepedate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.accepedate).format("DD/MM/YYYY") ;
            // let acceptedTime= (moment(rWorkPermit.accepedate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.accepedate).format("h:mm:ss A") ; 
            // let acceptedByDepartment= rWorkPermit.acceptedbydepartment || '';

            // let clearedComment = rWorkPermit.clearedcomment || '';
            // let clearedByName = rWorkPermit.clearedbyname || '';
            // let clearedTime = (moment(rWorkPermit.cleareddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.cleareddate).format("h:mm:ss A") ;
            // let clearedDate = (moment(rWorkPermit.cleareddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.cleareddate).format("DD/MM/YYYY") ;
            
            

            // let cancelledByName = rWorkPermit.cancelledbyname || '';
            // let cancelledTime = (moment(rWorkPermit.cancelleddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.cancelleddate).format("h:mm:ss A");
            // let cancelledDate = (moment(rWorkPermit.cancelleddate).format("DD/MM/YYYY") == 'Invalid date') ? '' : moment(rWorkPermit.cancelleddate).format("DD/MM/YYYY");

            //assingning variable from response(end)

            //first page table calculations started
            let firstPageWcdTableHght = (ECLine.length > 0) ? 40 : 10;

            //first page table calculations ended


            //precaution table calculations started

            ECLineTableHeader = [
                    [{
                    content: 'Expense Sub Category',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Expenditure Date',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Amount in Original Currency',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Original Currency',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, 
                    {
                    content: 'Exchange Rate',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, 
                    {
                    content: 'Amount in KWD',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, 
                    {
                    content: 'Description',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, 
                    {
                    content: 'Family Members',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},]
                ];
                ECLineTableBody = ECLine.map((el, index) => {
                    return[
                        //    {
                        //    content: index + 1,
                        //    styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                        //    }},
                            {
                            content: el.expenseSubCategory || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: moment(el.expenditureDate).format('DD/MM/YYYY')  || '' ,
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.amountInriginalCurrency || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.originalCurrency || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content:  el.exchnageRate ,
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.amountInKWD || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.description || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.familyMembers || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                        ]
                    
                })
                ////ECLineTableBody.splice(0, 1);
                ECLineTableData =ECLineTableHeader.concat(ECLineTableBody);
           

                ECApprovalsTableHeader = [
                    [{
                    content: 'Approval Stage',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Approver Name',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Position',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }},
                    {
                    content: 'Date',
                    styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                    }}, ]
                ];
                ECApprovalsTableBody = ECApproval.map((el, index) => {
                    return[
                            {
                            content: el.approvalstage || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.name || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.position || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                            {
                            content: el.approvaldate  || '',
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontSize: 10, font: 'calibri'|'times'|'courier',lineColor: 'black', 
                            }},
                        ]
                    
                })
                ////ECLineTableBody.splice(0, 1);
                ECApprovalsTableData =ECApprovalsTableHeader.concat(ECApprovalsTableBody);
           

            
            
            

            //precaution table calculations ended


            //safety catalog calculations start

            //safety catalog calculations end

            // pdf generation starts
            var doc = new jsPDF('p', 'mm', 'a4', 3);//jsPDF(orientation, unit, format)
            let text = '';
            doc.setFontStyle('normal');
            doc.setFont("Courier");  
            doc.setFontSize(10);
        
            doc.autoTable({
                theme: 'grid',
                didDrawCell: function(data) {
                    if (data.column.index === 0 && data.cell.section === 'body') {
                        var dim = data.cell.height - data.cell.padding('vertical');
                       doc.addImage(baseLogoImg, 'PNG', 7, 1, 60, 20);
                    }
                  },
                startY: 7,
                margin: {
                    left: 8.5
                },
                columnStyles: { 0: { cellWidth: 25, }},
                lineWidth: 18,
                body: [
                        [
                            {
                            content: "",
                            rowSpan: 2,
                            styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},                                                                                   
                        ], 
                        // [
                        //     {
                        //     content: "SELLER",
                        //     styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        //     }},
                        //     {
                        //     content: "BUYER",
                        //     styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier', lineColor: 'black',
                        //     }},
                        // ],
                        // [
                        //     {
                        //     content: "Name: " + Name + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
                        //     styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',  
                        //     }},
                        //     {
                        //     content: "Name: " + Name + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
                        //     styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        //     }},

                        // ],
                        
                ]
                
            });
             previousTableEnding = doc.lastAutoTable.finalY;
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 10,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                lineWidth: 5,
                body: [
                    [
                        {
                        content: "Expense Claim",
                        styles: { halign: 'center', valign:'top', textColor: 'black',fillColor: 'rgb(228, 245, 255)', fontStyle: 'bold', fontSize: 17, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},

                    ]
                ]

            });  

            previousTableEnding = doc.lastAutoTable.finalY;
           
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 5,
                     margin: {
                    left: 5,
                    right: 35
                },
                tableWidth: 200,
                columnStyles: { 0: { cellWidth: 55, }},
                lineWidth: 35,
                body: [
                        [
                            {
                            content: "Requester Name: ",
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
                            {
                                content: "Position: ",
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }}, 


                        {
                            content: "Department: ",
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }
                        },  
                        {
                            content: "Date of Join: ",
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }
                        },  
  
                    ], 
                    
                    [
                        {
                        content:  Requestername + "\n" ,
                        styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},
                        {
                            content: position + "\n" ,
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }}, 


                    {
                        content: department + "\n" ,
                        styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }
                    },  
                    {
                        content:  moment(doj).format('DD/MM/YYYY') + "\n" ,
                        styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }
                    },  

                    ], 


                        
                ]
                
            });                        


            previousTableEnding = doc.lastAutoTable.finalY;
           
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 5,
                     margin: {
                    left: 5,
                    right: 35
                },
                tableWidth: 200,
                columnStyles: { 0: { cellWidth: 55, }},
                lineWidth: 35,
                body: [
                        [
                            {
                            content: "EC Number: ",
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
                            {
                                content: "EC Date: ",
                                styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }}, 


                        {
                            content: "Travel Authorization: ",
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }
                        },  
                        {
                            content: "Total Amount In KWD: ",
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }
                        },  
  
                    ], 
                    [
                        {
                        content: ECnumber + "\n" ,
                        styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},
                        {
                            content:  moment(ECdate).format('DD/MM/YYYY'),
                            styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }}, 


                    {
                        content:  travelAuthorization + "\n" ,
                        styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }
                    },  
                    {
                        content: totalAmountInKWD + "\n" ,
                        styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }
                    },  

                    ], 

                        
                ]
                
            });            

            let previousTableEnding = doc.lastAutoTable.finalY;
           
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 5,
                     margin: {
                    left: 5,
                    right: 35
                },
                tableWidth: 200,
                columnStyles: { 0: { cellWidth: 35, }},
                lineWidth: 35,
                body: [

                        [
                            {
                            content: "Expense Type:",
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},
                            {
                            content: "Category",
                            styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier', lineColor: 'black',
                            }},
                        ],
                        [
                            {
                            content: expenseType + "\n" ,
                            styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',  
                            }},
                            {
                            content:  category + "\n" ,
                            styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                            }},

                        ],
                        
                ]
                
            });      
            
            previousTableEnding = doc.lastAutoTable.finalY;
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 5,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                lineWidth: 2,
                body: [
                    [
                        {
                        content: "Comment: " + comment,
                        styles: { halign: 'left', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},

                    ]
                ]

            });  


  
            previousTableEnding = doc.lastAutoTable.finalY;

            // work permit generation ending

            //safety catalog table generation started
            let pageNumber1 = doc.internal.getCurrentPageInfo().pageNumber;// test to print safety catalog on next page to avoid overlapping 

            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 7,
                styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [252, 245, 255]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                body: ECLineTableData,

            });


            previousTableEnding = doc.lastAutoTable.finalY;

            // work permit generation ending

 
            doc.autoTable({
                theme: 'grid',
                startY: previousTableEnding + 7,
                styles : { halign : 'center'}, headStyles :{fillColor : [255, 244, 251]}, alternateRowStyles: {fillColor : [224, 244, 251]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                body: ECApprovalsTableData,

            });            



            previousTableEnding = doc.lastAutoTable.finalY;
            doc.autoTable({
                theme: 'grid',
                styles : { halign : 'center'}, headStyles :{fillColor : [124, 95, 240]}, alternateRowStyles: {fillColor : [231, 215, 252]}, tableLineColor: [124, 95, 240], tableLineWidth: 0.1,
                startY: 270,
                margin: {
                    left: 5
                },
                tableWidth: 200,
                body: [
                    [
                        {
                        content: "This is system Generated Expence Claim Document. No Signature Required",
                        styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
                        }},
                        
                    ],
                    

                ]

            });             

            //safety catalog table generation ended

            //transfer record creation
    
            // doc.autoTable({
            //     theme: 'grid',
            //     didDrawCell: function(data) {
            //         if (data.column.index === 0 && data.cell.section === 'body') {
            //             var dim = data.cell.height - data.cell.padding('vertical');
            //            doc.addImage(baseLogoImg, 'JPEG', 3, 7, 35, 15);
            //         }
            //       },
            //     startY: 5,
            //     margin: {
            //         left: 1.5
            //     },
            //     columnStyles: { 0: { cellWidth: 45, }},
            //     lineWidth: 15,
            //     body: [
            //             [
            //                 {
            //                 content: "",
            //                 rowSpan: 2,
            //                 styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},
            //                 {
            //                 content: "EC Number: " + ECnumber,
            //                 styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},
            //                 {
            //                     content: "EC Date: " + ECdate,
            //                     styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }}, 
            //                 {
            //                     content: "Due Date: " + Duedate,
            //                     styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},
            //                 {
            //                     content: "Currency: " + Currency,
            //                     styles: { halign: 'center', valign:'top', cellWidth: '7', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},                                                                                   
            //             ], 
            //             [
            //                 {
            //                 content: "SELLER",
            //                 styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},
            //                 {
            //                 content: "BUYER",
            //                 styles: { halign: 'center', valign:'top', textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier', lineColor: 'black',
            //                 }},
            //             ],
            //             [
            //                 {
            //                 content: "Name: " + dpSheetNumber + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
            //                 styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',  
            //                 }},
            //                 {
            //                 content: "Name: " + dpSheetNumber + "\n" + "Building No: " + BuildingNo + "\n" + "Street Name: " + Street + "\n" + "District: " + District + "\n" + "City: " + City + "\n" + "Country: " + CountryName + "\n" + "Postal Code: " + PostalCode + "\n" + "Additional No: " + AdditionalNo + "\n" + "VAT No: " + VatNo,
            //                 styles: { halign: 'center',  textColor: 'black', fontStyle: 'bold', fontSize: 11, font: 'calibri'|'times'|'courier',lineColor: 'black',
            //                 }},

            //             ],
                        
            //     ]
                
            // });




            if(type === 'print'){
                doc.autoPrint()
                window.open(doc.output('bloburl'), ECnumber)
                this.setState({ loading: false });
                resolve("Promise Resolved");
            } else if(type === 'view'){
                window.open(doc.output('bloburl'), ECnumber)
                this.setState({ loading: false });
                resolve("Promise Resolved");
            } else if (type === 'download'){
                doc.save(ECnumber);
                this.setState({ loading: false });
                resolve("Promise Resolved");
            } else if(type === 'upload'){ 
                let pdf = btoa(doc.output());
                let FileName = ECnumber;
                let Folder = 'VendorRegistration';
                let Attachment = pdf;
                let MailData = {
                    FileName,
                    Folder,
                    Attachment
                }
    
                let dd = JSON.stringify(MailData);
                let  generatedPdf = {Key : dd};
                resolve(JSON.stringify(generatedPdf));                
            }
        })).catch((err) => {
            if(type === 'upload'){ // to prevent multiple error messages when this method is used in "saveRequest" method
                this.setState({ loading: false })
                reject("Promise Failed");
            } else {
                this.setState({ loading: false })
                this.growl.show({ severity: 'error', summary: null, detail: 'Cannot Download Vendor Registration. Please try again.' });
                reject("Promise Failed");
            }
        })
    })
    }   

    componentDidMount() {
        try {
            const { getContainerData, getKeywordValues, getMasterKeywordList, fetchSubordinatesLists, location = {}, loggedUserDetail } = this.props;
            const type = this.props.match.params.type;
            // this.effectiveDateHandler()
            getContainerData(VENDORREGISTRATION_ID);//Get Container Data
            getKeywordValues('Employee');//Get Employee Dropdown list

            getMasterKeywordList('Employee');//Get Employee
            getMasterKeywordList('TA_Type');//Get Assignment Type Dropdown list
            getMasterKeywordList('ExpenseType');//Get Service Dropdown list
            getMasterKeywordList('City');//Get Destination City Dropdown list 
            // getKeywordValues('currency');//Get currency Dropdown list. Need to be commented because interfering with the employee list and subordinate list when uncommented
            getMasterKeywordList('HDSCategory');//Get Employee
            getMasterKeywordList('HDSSubCategory');//Get Employee
            getMasterKeywordList('currency');//Get Employee
            getMasterKeywordList('COUNTRY');//Get Employee
            getMasterKeywordList('BusinessType')
            let requestedFor = ""
            let hasLoadedOnce = false
            // this.getCurrencyList()
       


       




            if (type === 'edit') {
                this.props.getRequestAttributeData(this.props.match.params.id);
                const selectedCategoryOptions = categoryList;
                this.setState({ categoryOptionsState: selectedCategoryOptions })
            }

            fetchSubordinatesLists(this.props.loggedUserDetail.empID, this.props.loggedUserDetail.CompanyId);
            const clearTimer = () => clearInterval(interval);
            const interval = setInterval(() => {
                const stageSequence = (location.state && location.state.stagesequence) || this.state.stageSequence;
                const requestId = this.props.match.params.id || this.state.requestId;
                const { tableLists, containerData } = this.props;
                const type = this.props.match.params.type;
                let requestattachments = tableLists.requestattachments || [];
                this.setState({ requestattachments });

                const container = containerData && Object.keys(containerData).length > 0 && containerData.stage || [];
                let process = containerData && Object.keys(containerData).length > 0 && containerData.stage || false;
                if (type === 'edit') {
                    process = tableLists && Object.keys(tableLists).length > 0 && tableLists.requestAttribute1 || false;
                    requestedFor = process && this.getFieldUsingFieldId("62de3040-ff47-4e92-a3de-62207db0bde7", process)?.fieldValue
                    if (requestedFor && !hasLoadedOnce) {
                        this.props.getrequestListgenp(requestedFor, '8AE27597-ADB2-491D-B592-7847A733BC05');
                        hasLoadedOnce = true
                    }
                }

                if (process && !this.props.loading) {
                    this.setState({ stageSequence, requestId, initialData: type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process });
                    setTimeout(() => this.initialize(type === 'edit' && process.length > 0 && process.concat(container.filter(((c, i) => i > (process.length - 1)))) || process, type === 'edit' ? 'edit' : 'add'), 3000);
                    clearTimer();
                }
            }, 300);
            
        }
        catch (error) {
            this.setState({error : error})
         }

    }
    componentDidUpdate(oldProps) {
        try
        {
        if (oldProps.reqlistgendata && this.props.reqlistgendata && oldProps.reqlistgendata.length != this.props.reqlistgendata.length && JSON.stringify(oldProps.reqlistgendata) != JSON.stringify(this.props.reqlistgendata)) {
            //this.initialize(this.state.initialData, 'progress');
            this.setState({
                reqliststate: this.props.reqlistgendata.reduce((a, el) => {
                      a.push(Object.assign({}, { label: el.label , value: el.value }));
                    return a;
                }, [])
            })
        }
        if (oldProps.dependantdata && this.props.dependantdata && oldProps.dependantdata.length != this.props.dependantdata.length && JSON.stringify(oldProps.dependantdata) != JSON.stringify(this.props.dependantdata)) {
            //this.initialize(this.state.initialData, 'progress');
            this.setState({
                dependantstate: this.props.dependantdata.reduce((a, el) => {
                    a.push(Object.assign({}, { label: el.label , value: el.value }));
                    return a;
                }, [])
            })
            }
        }
        catch (error) {
            this.setState({error : error})
         }

    }


    getCurrencyList() {
    axios.get("/master/api/DropDownValues/currency")
            .then(response => {
                if (response.status === 200) {
                    let index = 1;

                    currencyList = response.data.map(mod => {
                        return { label: `${mod.text} - ${mod.requestNum}`, value: index++, id: mod.requestNum,}
                    });
                }
            })
            .catch(err => {
                this.growl.show({ severity: 'success', summary: null, detail: 'Currency API Failed, Please reload the page' });
            })
    }

    handleMethods(type) {
        try
        {
        this.setState({ popupType: type });
        const { keywordValuesList } = this.props;
            this.setState({ dynamicSupervisorDisplay: true, DynamicSupervisorsList: keywordValuesList })
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    componentWillUnmount() {
        const { clearCacheStorage } = this.props;
        clearCacheStorage('request', { containerData: {}, requestAttributeData: {}, keywordValuesList: [] })
    }

    actionTemplate = (rowData) => {
        return <div>
            <Button type="button" icon="pi pi-pencil" className="p-button-info" onClick={() => this.setState({ editing: rowData })} />
        </div>;
    }

    currencyNameRender(rowData) {
        try
        {
        let currencyId = rowData.Original_Currency;
        let currency = currencyList.filter(currencies => currencies.label == currencyId);
        console.log({rowData,currencyId, currency})
        return (currency.length > 0 && currency[0].label) || '';
        }
        catch (error) {
            this.setState({error : error})
         }
    }


    renderInput(field, isContainerField, subIndex) {
        try
        {
        let isFieldVisible = true
        if (field.fieldId == "874cab07-e9c9-4e99-ac86-03b0cb83c50a") { // checking for TA
                       const expenseTypeFieldValue = this.getFieldUsingFieldId("b6778ee7-f3f6-4445-9066-f2edf1f9c511", this.state?.process)?.fieldValue
            if(!expenseTypeFieldValue || expenseTypeFieldValue === "18c28133-b20e-4a6a-91a7-1dfc4b77b0db") isFieldVisible = false 
            const categoryFieldValue = this.getFieldUsingFieldId("bb1c68e9-c4e2-4570-87b9-cdf79568abf2", this.state?.process)?.fieldValue      
            if(!categoryFieldValue || categoryFieldValue != "30a406ed-4c28-4639-84cd-bf30812f15ba") isFieldVisible = false 
        }
        if (field.fieldId == "255cb424-3659-4f96-8777-9d042ffb5750") { // checking for family members
            // const expenseTypeFieldValue = this.getFieldUsingFieldId("b6778ee7-f3f6-4445-9066-f2edf1f9c511", this.state?.process)?.fieldValue
            // if(!expenseTypeFieldValue || expenseTypeFieldValue === "19c28133-b20e-4a6a-91a7-1dfc4b77b0db") isFieldVisible = false 
            const categoryFieldValue = this.getFieldUsingFieldId("bb1c68e9-c4e2-4570-87b9-cdf79568abf2", this.state?.process)?.fieldValue      
            if(!categoryFieldValue || (categoryFieldValue != "30a406ed-4c28-4639-84cd-bf30812f13ba" && categoryFieldValue != "30a406ed-4c28-4639-84cd-bf30812f14ba" && categoryFieldValue != "30a406ed-4c28-4639-84cd-bf30812f20ba")) isFieldVisible = false 

        }
        if (isFieldVisible) {
        return isContainerField ? (<div key={subIndex} className={"p-col-12 p-md-6 p-lg-4"}><Inputs
            field={field}
            type={field.fieldDescription === 'Amount in Original Currency' ? "number" : null}
            disabled = {field.fieldDescription === 'Total Amount in KWD' ? true : false}
            value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
            process={this.state?.process}
            onInputChange={(e) => this.handleChange(e, field)}
            {...this.props}
                {...this.state} /></div>) : <Inputs
            field={field}
            disabled = {field.fieldDescription === 'Total Amount in KWD' ? true : false}
            type={field.fieldDescription === 'Amount in Original Currency'? "number":null}
            value={field.fieldType === '3' && field.fieldValue ? field.fieldValue.split(",") : field.fieldValue}
            process={this.state?.process}
            onInputChange={(e) => this.handleChange(e, field)}
            {...this.props}
                {...this.state} /> 
            
            }
        }
        catch (error) {
            this.setState({error : error})
         }
    }

    render() {
        try
        {

        const { tableLists, location = {}, metaData = {} } = this.props;
        const { state = {} } = location;
        const { process, stageSequence, currentSequence, editing,SubcategoryOptionsState } = this.state;
        const pendingWith = location && location.state && location.state.pendingWith;
            const requestFrom = location && location.state && location.state.requestFrom;
            const requestedFor = process && this.getFieldUsingFieldId("62de3040-ff47-4e92-a3de-62207db0bde7", process)?.fieldValue;
        

        const pageType = this.props.match.params.type;
        const status = (location.state && location.state.editStatus) || (tableLists && Object.keys(tableLists).length > 0 && tableLists.status) || false;  
        const dialogDynamicFooter = (
            <div>
                <Button icon="pi pi-times" onClick={() => this.setState({ dynamicSupervisorDisplay: false, DynamicSupervisor: null, DynamicSupervisorsList: null })} label="Close" className="p-button-secondary" />
                <Button onClick={() => this.saveRequest(this.state.popupType || 'submit')} icon="pi pi-check" disabled={(this.state.DynamicSupervisor === null)} label="Submit" className="p-button-primary  ml1" />
            </div>
        );
        
        
        // if (!SubcategoryOptionsState && process !== "undefined" && process.length !=0 && pageType === 'edit') {
        //     // let catg = "";
        //     // let cat = this.state.process.filter((p, i) => i == 0).map(stage =>  stage.stage_Field.filter(field => {
                    
        //     //     return (field.fieldDescription === 'Category');
        //     // }))
        //     // if(cat[0][0].fieldValue){
        //     //      catg = cat[0][0].fieldValue;
                
        //     // }
        //     // let exptype = process && this.getFieldUsingFielddesc('Expense Type', process, 0)?.fieldValue.toUpperCase()
        //     // //const exptypeu = exptype.toUpperCase();
        //     // const selectedCategoryOptions = this.props.categoryOptions.filter(category => category.id === exptype)
        //     // this.setState({categoryOptionsState: selectedCategoryOptions})
        //         // if(selectedCategoryValue== '18C28133-B20E-4A6A-91A7-1DFC4B77B0DB')
        //         // {
        //         //     this.setState({reqliststate: []})
        //         // }




        //     let catg = process && this.getFieldUsingFielddesc('Category', process, 0)?.fieldValue
        //     catg = catg && catg.toUpperCase()
          
        //         const selectedCategoryValue = catg;
        //         const selectedSubCategoryOptions = this.props.SubcategoryOptions.filter(category => category.id === selectedCategoryValue)
        //         if (selectedCategoryValue === '30A406ED-4C28-4639-84CD-BF30812F15BA') {   //travel authorization
        //             setTimeout(() => {
                     
                      
        //               //  this.props.getrequestListgenp(this.props.userPosInfo.empID, '8AE27597-ADB2-491D-B592-7847A733BC05');

        //                 this.props.getrequestListgenp(  requestedFor, '8AE27597-ADB2-491D-B592-7847A733BC05');
                
        //             }, 100);
        //             this.setState({ loading: true });
        //             const reqlist = (this.props.reqlistgendata !== undefined) ? this.props.reqlistgendata : [{ label: "-Select-", value: "00000000-0000-0000-0000-000000000000" }];
        //             // const reqlist = this.props.reqlistgendata;
        //             this.setState({ reqliststate: reqlist })
        //             this.setState({ loading: false });
        //         }
        //         else if (selectedCategoryValue === '30A406ED-4C28-4639-84CD-BF30812F13BA') {   // Chlldren Education  
        //             if (requestedFor == 'undefined') {
        //                 this.props.getdependantp(this.props.userPosInfo.empID, '2');
        //             }
        //             else
        //             {
        //                 this.props.getdependantp(requestedFor, '2');
        //             }
        //             this.setState({ loading: true });
        //             const dependant = (this.props.dependantdata !== undefined && this.props.dependantdata.length !== 0) ? this.props.dependantdata : [{ label: "-Select-", value: "00000000-0000-0000-0000-000000000000" }];
        //             this.setState({ dependantstate: dependant })
        //             this.setState({ loading: false });
        //         }
        //         else if (selectedCategoryValue === '30A406ED-4C28-4639-84CD-BF30812F14BA' || selectedCategoryValue == '30A406ED-4C28-4639-84CD-BF30812F20BA') {  // Immigration                   
        //             if (requestedFor == 'undefined') {
        //                 this.props.getdependantp(this.props.userPosInfo.empID, 'KW01');
        //             }
        //             else {
        //                 this.props.getdependantp(requestedFor, 'KW01');
        //             }
        //             this.setState({ loading: true });
        //             const spouse = (this.props.dependantdata !== undefined && this.props.dependantdata.length !== 0) ? this.props.dependantdata : [{ label: "-Select-", value: "00000000-0000-0000-0000-000000000000" }];
        //             this.setState({ dependantstate: spouse })
        //             this.setState({ loading: false });
        //         }
        //         else {

        //             this.setState({ dependantstate: [], reqliststate: [] })
        //         }

        //         this.setState({ SubcategoryOptionsState: selectedSubCategoryOptions })
           
        // }


        return (
            <div className="p-grid leaverequest">
                {(this.props.loading || this.state.loading) && <div className="page-loader"></div>}
                {(this.props.error !== null || this.state.error) && <Messages type="error" message={this.props.error || this.state.error} />}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{ position: 'relative' }}>
                        <h1>
                            Vendor Registration
                            <Link to={'/VendorRegistration'}>
                                <Button style={{ float: 'right' }} label="Back" icon="pi pi-arrow-left" className="ml1 p-button-secondary" />
                            </Link>
                        </h1>
                        <UserInfo userObject={this.props.userPosInfo} requestNum={state.requestNum} />
                    </div>
                </div>
                

                
                {process.filter((p, i) => i <= parseInt(stageSequence)).map((stage, stageIndex) => {
                    const { stage_Field, description } = stage;
                    const stageField = arraySort(stage_Field, 'fieldSequence');
                    
                    return <div key={stageIndex} className="p-col-12">
                        <div className="card card-w-title">
                            <h1>{description}</h1>
                            <div className="p-grid">
                                {(stageField || []).map((field, fieldIndex) => {
                                    const containerGroup = field.fieldType === '9' && lodash.mapValues(lodash.groupBy(stageField.filter(_ => _.parentFieldId === field.fieldName), 'childRowNmbr')) || false;
                                    const containerFields = (containerGroup && Object.keys(containerGroup).length > 0 && editing && editing.parentFieldId === field.fieldName && containerGroup[editing.childRowNmbr]) || (containerGroup && Object.keys(containerGroup).length > 0 && containerGroup[Object.keys(containerGroup).length - 1]) || [];
                                    const containerTable = containerGroup && Object.keys(containerGroup).length > 0 && Object.keys(containerGroup).filter((g, i) => i != Object.keys(containerGroup).length - 1).reduce((tableRow, row) => {
                                        const rowFields = containerGroup[row].reduce((r, c) => {
                                            const DropdownValues = metaData[c.fieldDescription] && c.fieldValue && metaData[c.fieldDescription].find(_ => _.value === c.fieldValue) || false;
                                            return Object.assign({}, { ...r }, { [c.fieldDescription.replaceAll(' ', '_')]: (DropdownValues && DropdownValues.label) || ((c.fieldType === '7' || c.fieldType === '8') && moment(c.fieldValue).format('MM/DD/YYYY')) || c.fieldValue, childRowNmbr: c.childRowNmbr, parentFieldId: c.parentFieldId })
                                        }, {});
                                        tableRow.push(rowFields);
                                        return tableRow;
                                    }, []) || [];
                                   
                                    return field.parentFieldId === "000" ? <div key={fieldIndex} className={field.fieldType === "9" || field.fieldType === "6" ? "p-col-12" : "p-col-12 p-md-6 p-lg-4"}>
                                        {field.fieldType != "9" ? this.renderInput(field) :
                                            field.fieldType === '9' ?
                                                <Fieldset legend={field.fieldDescription} toggleable collapsed={this.state[field.fieldName] === undefined ? false : this.state[field.fieldName]} onToggle={(e) => this.setState({[field.fieldName]: e.value})} style={{border: this.state[field.fieldName] === undefined || this.state[field.fieldName] ? 'none' : '1px solid rgba(0, 0, 0, 0.38)'}}>
                                                    <div className="p-grid">
                                                        {containerFields.map((subField, subIndex) => this.renderInput(subField, true, subIndex))}
                                                        <div className="p-col-12 p-md-6 p-lg-4">
                                                            {editing && editing.parentFieldId === field.fieldName ? <div className="mt2" style={{ padding: '8px' }}>
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-pencil" onClick={() => this.setState({ editing: false })} label="Update" style={{ marginRight: '10px' }} />
                                                                <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" onClick={() => this.setState({ editing: false })} label="Cancel" />
                                                            </div> : <div className="mt2" style={{ padding: '8px' }}>
                                                                    <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} className="p-button-primary" icon="pi pi-plus" onClick={() => this.handleContainer(field)} label="Add" />
                                                                </div>}
                                                        </div>{console.log({containerTable, containerFields})}
                                                        <div className="p-col-12">
                                                            <DataTable className="animated fadeInLeft" rowHover emptyMessage="No records found..." responsive={true}
                                                            expandableRowGroups={false} expandedRows={this.state.expandedRows} onRowToggle={(e) => { this.setState({ expandedRows: e.data }) }}
                                                            rowExpansionTemplate={this.rowExpansionTemplate} 
                                                            dataKey="childRowNmbr" rows={10} value={containerTable}>
                                                            <Column expander={true} style={{ width: '3em' }} />
                                                                {containerFields.map((columnField, columnIndex) =>
                                                                    (pageType == 'edit' & columnField.fieldDescription == 'Original Currency') ? <Column key={columnIndex} field={columnField.fieldDescription.replaceAll(' ', '_')} header={columnField.fieldDescription} body={this.currencyNameRender} /> : <Column key={columnIndex} field={columnField.fieldDescription.replaceAll(' ', '_')} header={columnField.fieldDescription} /> 
                                                                    )}
                                                                {
                                                                    ((pageType === 'edit' && (parseInt(stageSequence) === 0 || parseInt(stageSequence) === 1) && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null)) ? null : <Column body={this.actionTemplate} header="Action" style={{ textAlign: 'center', width: '8em' }} />
                                                                }
                                                            </DataTable>
                                                        </div>
                                                    </div>
                                                </Fieldset> : null}
                                    </div> : null

                                })}


                                {( stage.stageNum == '000' || stage.stageSequence == 0)  ? 
                                <div className="p-col-12 p-md-12 p-lg-12">
                                     <Attachments 
                                     handleAttachment = {this.handleAttachment} 
                                     folderName = 'VendorRegistration'
                                     reloadedValues = {this.state.requestattachments}
                                     isReloaded = {(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false}
                                     /> 
                                </div> 
                                    :
                                 null}

                                {stageIndex > 0 ?
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Approve" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Reject" onClick={() => this.saveRequest('reject')} className="p-button-danger ml1" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Return" onClick={() => this.saveRequest('return')} className="p-button-warning ml1" />
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Forward" onClick={() => this.handleMethods('forward')} className="ml1" />
                                        <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} label="Delegate" onClick={() => this.handleMethods('delegate')} className="p-button-info ml1" /> */}
                                        {/* <Button disabled={(pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" /> */}
                                        <Link to={'/VendorRegistration'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div> :
                                    
                                    <div className="p-col-12 p-md-12 p-lg-12" >
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('save')} className="p-button-secondary ml1" label="Save" icon="pi pi-save" />
                                        <Button disabled={(requestFrom == 'Request Involved') || (pageType === 'edit' && parseInt(stageSequence) === 0 && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : false} onClick={() => this.saveRequest('submit')} className="p-button-success ml1" label="Submit" icon="pi pi-save" />
                                        <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} />

                                        <Button disabled={(pageType === 'add') || (pageType === 'edit' && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? true : true} label="Download" onClick={() => this.generateEC('download')} className="p-button-success ml1" />
                                        {/* <Button disabled={status && status === 'Closed' && pendingWith === 'Closed' ? false : true} className="p-button-danger ml1" label="Cancel" style={{ marginRight: '10px' }} onClick={() => this.saveRequest('cancel')} /> */}
                                        <Button disabled={(pageType === 'edit' && pendingWith !== null) || (pageType === 'edit' && parseInt(stageSequence) != stageIndex) || (status && status === 'Closed' && pendingWith !== null) ? false : true} label="Print" onClick={() => this.generateEC('print')} className="p-button-success ml1" />
                                         
                                        <Link to={'/VendorRegistration'}>
                                            <Button className="p-button-secondary ml1" label="Close" icon="pi pi-times" />
                                        </Link>
                                    </div>}
                            </div>
                        </div>
                    </div>
                })}


                <Dialog header={this.state.dialogBoxText} visible={this.state.dynamicSupervisorDisplay} modal={true} width="400px" footer={dialogDynamicFooter} onHide={() => this.setState({ dynamicSupervisorDisplay: false })}>
                    <div className="p-grid">
                        <div className="p-col-12 p-lg-12">
                            <label className="label">{this.state.dialogBoxText}<span className="requiredColor">*</span></label>
                            <div className="mt1">
                                <Dropdown placeholder={this.state.dialogBoxText} name="DynamicSupervisor" value={this.state.DynamicSupervisor} options={this.state.DynamicSupervisorsList} onChange={(e) => this.setState({ DynamicSupervisor: e.target.value })}   {...DROPDOWN_CONFIG} style={{ width: '100%' }} />
                            </div>
                        </div>
                    </div>
                </Dialog>

            </div>

        );

    }
    catch (error) {
        this.setState({error : error})
     }
    }
}

const mapStateToProps = state => {
    const dependantdata = (state.master.dependantdata!== undefined) ? state.master.dependantdata : [];
    const reqlistgendata = (state.master.requestlistgendata !== undefined) ? state.master.requestlistgendata : []; 
    const Employee = (state.keyword.Employee !== undefined) ? state.keyword.Employee : [];
    const loggedUserDetail = state.auth.userObject || {};
    const subordinatesList = ([Object.assign({}, { label: `${state.auth.userObject.userName}-Self`, value: state.auth.userObject.empID })]).concat(state.master.subordinatesListData);
    const keywordValuesList = state.master.keywordValuesList.reduce((a, el) => {
        if (el.uniqueId !== state.auth.userObject.empID) {
            a.push(Object.assign({}, {...el}, {value: el.uniqueId}));
        }
        return a;
    }, [Object.assign({}, state.master.keywordValuesList.find(list => list.uniqueId === state.auth.userObject.empID), {label: `${state.auth.userObject.userName}-Self`, value:state.auth.userObject.empID , id: parseInt(state.auth.userObject.userID)})]);  
    return {
        loggedUserDetail,
        userPref: state.auth.userPref,
        userPosInfo: state.auth.userPosInfo,
        loading: state.master.loading || state.keyword.loading,
        error: state.master.error || state.keyword.error,
        containerData: state.master.containerData,
        tableLists: state.master.requestAttributeData,
        subordinatesListData: subordinatesList,
        Employee,
        currencyList: state.keyword.currency,
        categoryList: categoryList && categoryList || [],
        categoryOptions:state.keyword.HDSCategory,
        SubcategoryOptions:state.keyword.HDSSubCategory,
        keywordValuesList,
        reqlistgendata,
        dependantdata,
        metaData: Object.assign({}, {
            "Assignment Type": state.keyword.TA_Type,
            "Destination City": state.keyword.City,
            "Expense Type": state.keyword.ExpenseType,
            //         "Original Currency": currencyList,
            "Original Currency": state.keyword.currency,
            "Country": state.keyword.COUNTRY,
           "Business Type": state.keyword.BusinessType,
            "Category":state.keyword.HDSCategory,
            "Expense Sub Category":state.keyword.HDSSubCategory,
            "Travel Authorization":reqlistgendata,
            "Family Members":dependantdata
        })
    }
}


const mapDispatchToProps = dispatch => {
    return {
        getContainerData: (process_Id) => dispatch(actions.getContainerData(process_Id)),
        getMasterKeywordList: (keyword) => dispatch(actions.getMasterKeywordList(keyword)),
        fetchSubordinatesLists: (empId, compId) => dispatch(actions.fetchSubordinatesLists(empId, compId)),
        getKeywordValues: (value) => dispatch(actions.getKeywordValues(value)),
        processDynamicData: (model, type, data, func) => dispatch(actions.processDynamicData(model, type, data, func)),
        getRequestAttributeData: (id) => dispatch(actions.getRequestAttributeData(id)),
        clearCacheStorage: (type, data) => dispatch(actions.clearCacheStorage(type, data)),
        getrequestListgenp: (id, processId) => dispatch(actions.getrequestListgen(id, '8AE27597-ADB2-491D-B592-7847A733BC05')),
        getdependantp: (id, ftype) => dispatch(actions.getdependant(id, ftype))
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(VendorRegistration);